import { c as _c } from "react/compiler-runtime";
import { touchTargetClassName } from "@/components/ui/control-surface";
import * as SliderPrimitive from "@radix-ui/react-slider";
import * as React from "react";
import cn from "twsx";

// A 4px track with an accent range and a 14px surface thumb, the same track as
// Progress. One thumb per value; the thumb carries the accessible name.
/** Use when a person picks a number from a continuous range, such as zoom or crop size. */
const Slider = t0 => {
  const $ = _c(19);
  let ariaLabel;
  let className;
  let defaultValue;
  let props;
  let ref;
  let value;
  if ($[0] !== t0) {
    ({
      className,
      value,
      defaultValue,
      "aria-label": ariaLabel,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = className;
    $[3] = defaultValue;
    $[4] = props;
    $[5] = ref;
    $[6] = value;
  } else {
    ariaLabel = $[1];
    className = $[2];
    defaultValue = $[3];
    props = $[4];
    ref = $[5];
    value = $[6];
  }
  let t1;
  if ($[7] !== ariaLabel || $[8] !== className || $[9] !== defaultValue || $[10] !== props || $[11] !== ref || $[12] !== value) {
    const thumbs = (value ?? defaultValue ?? [0]).length;
    let t2;
    if ($[14] !== className) {
      t2 = cn("relative flex h-5 w-full touch-none select-none items-center", "data-[disabled]:pointer-events-none data-[disabled]:opacity-disabled", className);
      $[14] = className;
      $[15] = t2;
    } else {
      t2 = $[15];
    }
    let t3;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <SliderPrimitive.Track className="relative h-1 w-full grow overflow-hidden rounded-full bg-fill-hover"><SliderPrimitive.Range className="absolute h-full bg-accent" /></SliderPrimitive.Track>;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    let t4;
    if ($[17] !== ariaLabel) {
      t4 = (_, index) => <SliderPrimitive.Thumb key={index} aria-label={ariaLabel} className={cn("relative block size-3.5 cursor-grab rounded-full border border-border-input-hover bg-bg-surface shadow-low outline-none", "focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-accent", touchTargetClassName)} />;
      $[17] = ariaLabel;
      $[18] = t4;
    } else {
      t4 = $[18];
    }
    t1 = <SliderPrimitive.Root ref={ref} value={value} defaultValue={defaultValue} className={t2} {...props}>{t3}{Array.from({
        length: thumbs
      }, t4)}</SliderPrimitive.Root>;
    $[7] = ariaLabel;
    $[8] = className;
    $[9] = defaultValue;
    $[10] = props;
    $[11] = ref;
    $[12] = value;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  return t1;
};
Slider.displayName = SliderPrimitive.Root.displayName;
export { Slider };